import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { getFCMToken, onForegroundMessage } from '../../config/firebase.config';
import api from '../../services/api';
import { toast } from 'sonner';

export const useFCMRegistration = () => {
  useEffect(() => {
    const register = async () => {
      // ✅ SW ko manually root scope pe register karo
      if ('serviceWorker' in navigator) {
        try {
          const existing = await navigator.serviceWorker.getRegistration('/');
          if (!existing) {
            const reg = await navigator.serviceWorker.register(
              '/firebase-messaging-sw.js',
              { scope: '/' }
            );
            console.log('✅ SW registered at scope:', reg.scope);
          } else {
            console.log('✅ SW already registered at scope:', existing.scope);
          }
        } catch (err: any) {
          console.error('❌ SW registration failed:', err);
        }
      }

      const token =
        Cookies.get('token') ||
        Cookies.get('authToken') ||
        Cookies.get('access_token');

      if (!token) {
        console.warn('[FCM] No auth token in cookies');
        return;
      }

      try {
        const fcmToken = await getFCMToken();
        if (!fcmToken) return;

        const saved = localStorage.getItem('fcm_token');
        if (saved === fcmToken) return;

        await api.post('/device-tokens', {
          token: fcmToken,
          platform: 'web',
          deviceInfo: navigator.userAgent,
        });

        localStorage.setItem('fcm_token', fcmToken);
        console.log('✅ FCM token registered');
      } catch (err: any) {
        console.warn('FCM registration failed:', err.message);
      }
    };

    register();

    onForegroundMessage(async (payload) => {
  console.log('📩 Foreground message:', payload);

  const title = payload.notification?.title || 'New notification';
  const body = payload.notification?.body || '';
  const link = payload.data?.link || '/';

  // 1. Show toast (in-app feedback)
  toast(title, {
    description: body,
    action: link
      ? { label: 'View', onClick: () => (window.location.href = link) }
      : undefined,
  });

  // 2. ALSO show desktop notification (even when tab is active)
  try {
    if (Notification.permission === 'granted') {
  const reg = await navigator.serviceWorker.ready;
  console.log('[FCM] Calling showNotification with:', { title, body, link });
  try {
    await reg.showNotification(title, {
      body,
      data: { link },
      tag: payload.messageId || `notif-${Date.now()}`,
      requireInteraction: false,
    });
    console.log('[FCM] ✅ Desktop notification shown');
  } catch (err) {
    console.error('[FCM] ❌ showNotification failed:', err);
  }
}
  } catch (err) {
    console.warn('Desktop notification failed:', err);
  }
});
  }, []);
};